
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { useAIDisabled } from "@/utils/settings";
import { analyzeResumeWithAI } from "./analyze-resume";

/**
 * Triggers a re-analysis of a candidate's CV
 * @param candidateId - ID of the candidate
 * @param cvUrl - URL to the CV file
 * @param notes - Optional additional notes for analysis
 */
export const triggerReanalysis = async (
  candidateId: string,
  cvUrl: string | null,
  notes: string = ""
): Promise<void> => {
  try {
    // If AI is disabled, skip reanalysis
    if (useAIDisabled()) {
      console.log("Re-analysis skipped: AI features are disabled in settings");
      return;
    }
    
    console.log(`Triggering re-analysis for candidate ${candidateId}`);
    
    // Call the analyze function with minimal text content since we'll use the URL
    const result = await analyzeResumeWithAI(
      candidateId,
      cvUrl,
      "", // Empty text since we're using URL
      (stage, progress) => console.log(`Re-analysis progress: ${stage} - ${progress}%`),
      notes
    );
    
    console.log("Re-analysis completed:", result);
    document.location.href = document.location.href; // Refresh the page to reflect changes
    
    toast({
      title: "AI Analysis Updated",
      description: "Candidate profile has been re-analyzed with new information",
    });
  } catch (error) {
    console.error("Error during re-analysis:", error);
    toast({
      title: "AI Analysis Failed",
      description: `Could not update analysis: ${error instanceof Error ? error.message : 'Unknown error'}`,
      variant: "destructive",
    });
  }
};
